/* PageFly-free runtime for Liquid copies of PageFly pages (built by /root/pf2liquid-lp/build.py). Replaces the PageFly app scripts.
   Covers slideshows, product media gallery, accordion, quantity, add-to-cart and scroll-to-section buttons.
   Buying goes to the Shopify checkout (cart permalink, Onward Checkout+ off); the layout doesn't render fs-checkout-redirect. */
(function () {
  var root = document.querySelector('.__pf');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('lq-config').textContent) || {}; } catch (e) {}

  function on(node, fn) { node.addEventListener('click', fn); }

  function el(tag, cls, attrs) {
    var e = document.createElement(tag); if (cls) e.className = cls;
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    return e;
  }
  function settingsFor(node) {
    var m = (node.className || '').match(/pf-\d+_/); return (m && cfg[m[0]]) || {};
  }
  function bp() {
    var w = window.innerWidth;
    return w >= 1025 ? 'all' : w >= 992 ? 'laptop' : w >= 768 ? 'tablet' : 'mobile';
  }

  function findOrMake(scope, parent, cls, label, navStyle) {
    var b = scope.querySelector('.' + cls);
    if (!b) { b = el('button', cls + ' ' + navStyle + (navStyle === 'none' ? ' hide' : ''), { type: 'button', 'aria-label': label }); parent.appendChild(b); }
    return b;
  }

  /* Generic scroll-snap carousel: track holds slides, prev/next step one slide, dots per start position. */
  function carousel(track, slidesSel, opts) {
    var slides = [].slice.call(track.querySelectorAll(slidesSel));
    if (!slides.length) return null;
    function perView() {
      var first = slides[0].getBoundingClientRect().width || 1;
      return Math.max(1, Math.round(track.clientWidth / first));
    }
    function maxIndex() { return Math.max(0, slides.length - perView()); }
    function current() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - track.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      return Math.min(best, maxIndex());
    }
    function go(i) {
      var max = maxIndex();
      if (opts.loop) i = i > max ? 0 : i < 0 ? max : i; else i = Math.max(0, Math.min(max, i));
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }
    var prev = opts.prev, next = opts.next, dotsWrap = opts.dots;
    function sync() {
      var i = current(), max = maxIndex();
      if (prev) prev.style.visibility = (!opts.loop && i <= 0) || max === 0 ? 'hidden' : 'visible';
      if (next) next.style.visibility = (!opts.loop && i >= max) || max === 0 ? 'hidden' : 'visible';
      if (dotsWrap) {
        if (dotsWrap.children.length !== max + 1) {
          dotsWrap.innerHTML = '';
          for (var n = 0; n <= max; n++) (function (n) {
            var b = el('button', '', { type: 'button', 'aria-label': 'Go to slide ' + (n + 1) });
            on(b, function () { go(n); restart(); }); dotsWrap.appendChild(b);
          })(n);
        }
        [].forEach.call(dotsWrap.children, function (b, n) { b.classList.toggle('active', n === i); });
      }
      if (opts.onChange) opts.onChange(i);
    }
    if (prev) on(prev, function () { go(current() - 1); restart(); });
    if (next) on(next, function () { go(current() + 1); restart(); });
    var t, timer;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
    function restart() {
      if (!opts.autoPlay) return;
      clearInterval(timer);
      timer = setInterval(function () { if (document.visibilityState === 'visible') go(current() + 1); }, opts.autoPlayDelay || 3000);
    }
    sync(); restart();
    window.addEventListener('load', sync);
    if (window.ResizeObserver) new ResizeObserver(function () { clearTimeout(t); t = setTimeout(sync, 100); }).observe(track);
    return { go: go, current: current };
  }

  /* Slideshows */
  [].forEach.call(root.querySelectorAll('[data-lq-type="Slideshow"]'), function (box) {
    var s = settingsFor(box), track = box.querySelector('.pf-slider');
    if (!track) return;
    var navStyle = s.navStyle || 'none', pag = s.paginationStyle || 'none';
    // PageFly already server-renders the arrows and the dot row; reuse them, create only what is missing
    var prev = findOrMake(box, track, 'pf-slider-prev', 'Previous', navStyle);
    var next = findOrMake(box, track, 'pf-slider-next', 'Next', navStyle);
    var dots = null;
    if (pag !== 'none') {
      dots = box.querySelector('.pf-slider-nav');
      if (!dots) { dots = el('div', 'pf-slider-nav ' + pag); box.appendChild(dots); }
    }
    track.classList.add('has-loaded');
    carousel(track, '.pf-slide', {
      prev: navStyle === 'none' ? null : prev, next: navStyle === 'none' ? null : next, dots: dots,
      loop: !!s.loop, autoPlay: !!s.autoPlay, autoPlayDelay: s.autoPlayDelay
    });
    if (navStyle === 'none') { prev.style.visibility = next.style.visibility = 'hidden'; }
  });

  [].forEach.call(root.querySelectorAll('.product-media-loading'), function (n) { n.classList.remove('product-media-loading'); });

  /* Product media: main image slider + thumbnail list */
  [].forEach.call(root.querySelectorAll('[data-lq-type="ProductMedia2"]'), function (pm) {
    var main = pm.querySelector('[data-lq-type="MediaMain"], [data-lq-type="MediaMain2"]');
    var track = main && main.querySelector('.pf-media-slider');
    if (!track) return;
    var s = settingsFor(main), navStyle = s.navStyle || 'none';
    var thumbs = [].slice.call(pm.querySelectorAll('.pf-slide-list-media'));
    var slides = [].slice.call(track.querySelectorAll('.pf-slide-main-media'));
    track.style.scrollSnapType = 'x mandatory';
    slides.forEach(function (sl) { sl.style.scrollSnapStop = 'always'; });
    var prev = null, next = null;
    if (navStyle !== 'none') {
      prev = findOrMake(track, track, 'pf-slider-prev', 'Previous', navStyle);
      next = findOrMake(track, track, 'pf-slider-next', 'Next', navStyle);
    }
    track.classList.add('has-loaded');
    var c = carousel(track, '.pf-slide-main-media', {
      prev: prev, next: next, loop: false,
      onChange: function (i) {
        slides.forEach(function (sl, n) { sl.classList.toggle('is-current', n === i); sl.setAttribute('data-active', n === i ? 'true' : 'false'); });
        var id = slides[i] && slides[i].getAttribute('data-media-id');
        thumbs.forEach(function (th) { th.setAttribute('data-active', th.getAttribute('data-img-id') === id ? 'true' : 'false'); });
      }
    });
    thumbs.forEach(function (th) {
      on(th, function () {
        var id = th.getAttribute('data-img-id');
        for (var n = 0; n < slides.length; n++) if (slides[n].getAttribute('data-media-id') === id) { c && c.go(n); break; }
      });
    });
  });

  /* Accordion (one open at a time unless data-multiple="true") */
  [].forEach.call(root.querySelectorAll('[data-lq-type="Accordion"]'), function (acc) {
    var multiple = acc.getAttribute('data-multiple') === 'true';
    var headers = [].slice.call(acc.querySelectorAll('[data-lq-type="Accordion.Header"]'));
    function body(h) { return acc.querySelector('[data-lq-type="Accordion.Content"][data-id="' + h.getAttribute('data-header-id') + '"]'); }
    function set(h, open) { h.setAttribute('data-active', open ? 'true' : 'false'); var b = body(h); if (b) b.style.display = open ? '' : 'none'; }
    headers.forEach(function (h) {
      set(h, h.getAttribute('data-active') === 'true');
      h.addEventListener('click', function () {
        var open = h.getAttribute('data-active') !== 'true';
        if (open && !multiple) headers.forEach(function (o) { if (o !== h) set(o, false); });
        set(h, open);
      });
    });
  });

  /* Quantity +/- */
  [].forEach.call(root.querySelectorAll('[data-lq-type="ProductQuantity"]'), function (q) {
    var input = q.querySelector('input[name="quantity"]');
    if (!input) return;
    var cont = (input.getAttribute('data-variants-continue') || '').trim();
    var form = q.closest('form'), vid = form && form.querySelector('[name="id"]');
    if (cont && vid && cont.split(/\s+/).indexOf(vid.value) > -1) input.removeAttribute('max');
    var dec = q.querySelector('[data-quantity-action="decrease"]');
    function lock() { if (dec) dec.disabled = (parseInt(input.value, 10) || 1) <= (parseInt(input.min, 10) || 1); }
    input.addEventListener('change', lock); input.addEventListener('input', lock); lock();
    [].forEach.call(q.querySelectorAll('[data-quantity-action]'), function (b) {
      on(b, function () {
        var v = parseInt(input.value, 10) || 1, min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 9999;
        v += b.getAttribute('data-quantity-action') === 'increase' ? 1 : -1;
        input.value = Math.max(min, Math.min(max, v));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Buy flow (Markus 23.09): Shopify checkout via cart permalink /cart/<variant>:<qty>, carrying Onward's opt-out
     attributes so the order goes through without Checkout+ (same as the live pearl/ralf/rabbit/succulent builds). */
  // ClickMagick: the review site hands over ?cmc_vid=...; the cart link stamps it (plus cmcid/fbclid/gclid/cmc_adid and the
  // landing page's other query params, e.g. utm_*) onto the Shopify order as note attributes, where the CM Shopify app
  // attributes the sale. URL first (a stale cmc_vid cookie from an older visit can sit on cosara.com), then this tab's
  // saved copy, then the newest cookie. Same method as the other live Shopify-checkout pages.
  var CM = ['cmc_vid', 'cmcid', 'fbclid', 'gclid', 'cmc_adid'], sp = new URLSearchParams(location.search);
  CM.forEach(function (k) { var v = sp.get(k); if (v) { try { sessionStorage.setItem('cw_' + k, v); } catch (e) {} } });
  function cmVal(k) {
    var v = sp.get(k); if (v) return v;
    try { v = sessionStorage.getItem('cw_' + k); } catch (e) {} if (v) return v;
    var c = document.cookie.split('; ').filter(function (x) { return x.indexOf(k + '=') === 0; });
    return c.length ? decodeURIComponent(c[c.length - 1].slice(k.length + 1)) : '';
  }
  function firstForm() { return root.querySelector('form.pf-product-form'); }
  function cartUrl(variant, qty) {
    var u = new URL('/cart/' + variant + ':' + qty, location.origin);
    sp.forEach(function (v, k) { if (CM.indexOf(k) < 0) u.searchParams.set(k, v); });
    u.searchParams.set('channel', 'buy_button');
    u.searchParams.set('attributes[_onwardInsured]', 'false');
    u.searchParams.set('attributes[_hideOnwardCheckoutExtension]', 'true');
    CM.forEach(function (k) { var v = cmVal(k); if (v) u.searchParams.set('attributes[' + k + ']', v); });
    return u.pathname + u.search;
  }
  function checkout(form, qty) {
    var idEl = form && form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return false;
    window.location.href = cartUrl(idEl.value, qty);
    return true;
  }
  [].forEach.call(root.querySelectorAll('[data-lq-type="ProductATC2"]'), function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = btn.closest('form') || firstForm();
      var qEl = form && form.querySelector('[name="quantity"]');
      var qty = qEl ? parseInt(qEl.value, 10) || 1 : 1;
      var max = qEl ? parseInt(qEl.max, 10) || 9999 : 9999;
      if (checkout(form, Math.max(1, Math.min(max, qty)))) btn.textContent = btn.getAttribute('data-added') || 'Going to checkout...';
    });
  });
  // Enter in the quantity box (or any native submit) would post the form to /cart without the Onward opt-out
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('pf-product-form') || !root.contains(f)) return;
    e.preventDefault();
    var b = f.querySelector('[data-lq-type="ProductATC2"]') || root.querySelector('[data-lq-type="ProductATC2"]');
    if (b) b.click();
  }, true);
  // The sticky-bar "SHOP NOW" (no discount in the label) goes straight to checkout with 1 unit;
  // "SHOP 37% OFF NOW" keeps scrolling to the buy box (handled below).
  [].forEach.call(root.querySelectorAll('a[data-lq-to-section]'), function (a) {
    var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
    if (!/^SHOP\b/i.test(label) || /\d+\s*%/.test(label)) return;
    a.removeAttribute('data-lq-to-section');
    a.addEventListener('click', function (e) { e.preventDefault(); checkout(firstForm(), 1); });
  });


  /* Accordion3 (PageFly gen-2 FAQ): native <details>; keep one open unless data-open-multiple="true", mirror data-active */
  [].forEach.call(root.querySelectorAll('[data-lq-type="Accordion3"]'), function (acc) {
    var multiple = acc.getAttribute('data-open-multiple') === 'true';
    var items = [].slice.call(acc.querySelectorAll('details'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        var h = d.querySelector('[data-lq-type="Accordion3.Header"]');
        if (h) h.setAttribute('data-active', d.open ? 'true' : 'false');
        if (d.open && !multiple) items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  });

  /* Links to a product page (advertorials): carry the landing query params (utm_*, fbclid...) and the ClickMagick ids,
     so the product page can stamp them onto the order. */
  [].forEach.call(root.querySelectorAll('a[href*="/products/"], a[href^="/pages/"]'), function (a) {
    a.addEventListener('click', function () {
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        sp.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
        CM.forEach(function (k) { var v = cmVal(k); if (v && !u.searchParams.has(k)) u.searchParams.set(k, v); });
        a.href = u.toString();
      } catch (e) {}
    });
  });

  /* Buttons that scroll to a section (data-lq-to-section="pf-xxxx"). Missing targets do nothing, as on the original. */
  [].forEach.call(root.querySelectorAll('[data-lq-to-section]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var target = root.querySelector('[data-section-id="' + a.getAttribute('data-lq-to-section') + '"]');
      if (!target) return;
      var off = 0; try { off = (JSON.parse(a.getAttribute('data-offset') || '{}')[bp()]) || 0; } catch (x) {}
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
    });
  });

  /* Sticky buy bar: the original faded .sticky-boy in past 2000px of scroll and out above it (jQuery) */
  var sticky = [].slice.call(root.querySelectorAll('.sticky-boy'));
  if (sticky.length) {
    sticky.forEach(function (n) { n.style.transition = 'opacity .4s'; });
    var shown = null;
    var onScroll = function () {
      var show = window.pageYOffset > 2000;
      if (show === shown) return;
      shown = show;
      sticky.forEach(function (n) {
        if (show) { n.style.display = 'block'; requestAnimationFrame(function () { n.style.opacity = '1'; }); }
        else { n.style.opacity = '0'; setTimeout(function () { if (!shown) n.style.display = 'none'; }, 400); }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Elements with a click-through URL (logo) */
  [].forEach.call(root.querySelectorAll('[data-action="url"][data-href]'), function (n) {
    n.style.cursor = 'pointer';
    n.addEventListener('click', function () {
      var href = n.getAttribute('data-href'), tgt = n.getAttribute('data-target') || '_self';
      if (tgt === '_blank') window.open(href, '_blank', 'noopener'); else window.location.href = href;
    });
  });
})();
